import { ClipboardCheckIcon, StarIcon } from 'lucide-react';

import { useIsBetaFeatureEnabled } from '@/entities/beta-feature';
import { usePinnedDashboardPresetRoutes } from '@/entities/settings';
import { SidebarDynamicMenuItem } from '@/shared/lib';

/**
 * Пункты динамического подменю закреплённых дашбордов-пресетов под группой «Контроль».
 *
 * Пункт ведёт на адрес раздела своего пресета; сам пресет применяет адрес
 * (`useDashboardPresetSectionSync`). При выключенной бета-функции пользовательских
 * дашбордов пунктов нет вовсе — закреплённые пресеты остаются в настройках
 * пользователя и вернутся вместе с функцией.
 */
export const useDashboardPresetMenuItems = (): SidebarDynamicMenuItem[] => {
  const isPresetsEnabled = useIsBetaFeatureEnabled('CUSTOM_DASHBOARDS');
  const pinnedRoutes = usePinnedDashboardPresetRoutes();

  if (!isPresetsEnabled) {
    return [];
  }

  return pinnedRoutes.map(({ preset, path }) => ({
    key: preset.id,
    path,
    icon: (
      <span className="relative flex size-4 shrink-0">
        <ClipboardCheckIcon size={16} strokeWidth={1.25} />
        {/* Звезда закрепления сдвинута в угол значка — тело значка остаётся читаемым */}
        <span className="absolute -right-1 -bottom-1 flex items-center justify-center">
          <StarIcon size={8} strokeWidth={2.5} className="fill-current" />
        </span>
      </span>
    ),
    label: preset.name,
  }));
};
